import TreeSelect from "./TreeSelect";
export default TreeSelect;